import * as actionTypes from './actionTypes';


export const onGenerateOTPSuccess = (response)=> ({
    type:actionTypes.GENERATE_OTP_SUCCESS,
    response
});

export const onGenerateOTPFailed = (error)=> ({
    type:actionTypes.GENERATE_OTP_FAILED,
    error
});

export const onGenerateOTPStart  = (id, mobileNo) =>({
    type: actionTypes.GENERATE_OTP,
    sessionId: id,
    mobileNo
});
